/*
 *
 * ServiceRequestsManagerFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';

import { SERVICE_REQUESTS_MANAGER_REQUESTS_FORM, SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG } from './constants';

function ServiceRequestsManagerFormDialog({ form }) {
  return (
    <AdvancedFormDialog
      name={SERVICE_REQUESTS_MANAGER_REQUESTS_FORM_DIALOG}
      formName={SERVICE_REQUESTS_MANAGER_REQUESTS_FORM}
      advancedForm={form}
      addModeTitle="Новая заявка"
      editModeTitle="Изменение заявки"
      viewModeTitle="Просмотр заявки"
      copyModeTitle="Копирование заявки"
    />
  );
}

ServiceRequestsManagerFormDialog.propTypes = {
  form: PropTypes.node.isRequired,
};

export default ServiceRequestsManagerFormDialog;
